import { MediaDisplay } from "@package/ui-wall-components";
import { type PropsWithChildren } from "react";
import { useTriviaContext } from "../context-trivia";
import {
  getTriviaTypeScaleStyle,
  TRIVIA_SAFE_AREA_STYLE,
} from "../trivia-layout";
import { TriviaProgress } from "./TriviaProgress";

export function TriviaContainer({ children }: PropsWithChildren) {
  const { config } = useTriviaContext();
  const {
    backgroundMedia,
    logoMedia,
    overlayOpacity,
    primaryBackground,
    primaryText,
  } = config.theme;

  return (
    <div
      className="relative h-full w-full overflow-hidden"
      style={{
        ...getTriviaTypeScaleStyle(config),
        backgroundColor: primaryBackground,
        color: primaryText,
      }}
    >
      {!!backgroundMedia && (
        <div className="pointer-events-none absolute inset-0">
          <MediaDisplay
            id={backgroundMedia}
            alt=""
            forceFit
            classNameMedia="h-full w-full object-cover"
          />
        </div>
      )}
      {!!backgroundMedia && overlayOpacity > 0 && (
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundColor: primaryBackground,
            opacity: overlayOpacity,
          }}
        />
      )}
      <div
        className="relative flex h-full min-h-0 w-full flex-col gap-[var(--trivia-space)]"
        style={TRIVIA_SAFE_AREA_STYLE}
      >
        {!!logoMedia && (
          <div className="flex w-full flex-none items-center justify-center">
            <div className="h-[max(2rem,6cqmin)] w-auto">
              <MediaDisplay
                id={logoMedia}
                alt=""
                forceFit
                classNameMedia="h-full w-auto object-contain"
              />
            </div>
          </div>
        )}
        <TriviaProgress />
        <div className="flex min-h-0 w-full flex-1">{children}</div>
      </div>
    </div>
  );
}
